var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 287 310",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4bb857",
    d: "M144 303c0-7 0-7-4-7l-4 2-20 1H96v-43c0-44 0-44-5-44-2 0-2-2-2-4l-2-7c-1-2-1-6 1-17l3-19c0-4-1-5-6-5s-5 1-6 5c-1 5-2 6-17 6-9 0-10 0-12-3-1-2-3-2-7-2-8 0-20-7-27-15A74 74 0 0 1 1 96V83c-1-1 0-15 3-17l4-11c4-15 13-30 23-40 7-7 10-9 17-12l15-3c9-1 27 2 34 5 9 5 8 5 6 14v11c0 2 0 2 3 2s5-1 5-2c1-2 6-2 7 0s3 2 5 2h5V9l10-3c13-4 32-5 43-2 23 6 39 22 45 45 3 10 4 50 2 50l-1 3 1 4v79l29 22 30 23v16h-21l-25 1h-5v-13h-97v27l7 10c7 9 9 11 12 11 6 0 6 1 6 16v12h-20v-7z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 85,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: 37,
    fontWeight: 300,
    style: {
      InkscapeFontSpecification: "'Arial Bold'"
    },
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 121,
    y: 85,
    style: {
      textAlign: "center"
    },
    textAnchor: "middle"
  }, "Hope"), /*#__PURE__*/React.createElement("tspan", {
    x: 121,
    y: 131,
    style: {
      textAlign: "center"
    },
    textAnchor: "middle"
  }, "Building")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHope);
export default __webpack_public_path__ + "static/media/Hope.0dc0759112d258b5b94e59c91f36cbbe.svg";
export { ForwardRef as ReactComponent };